module.exports = __webpack_public_path__ + "media/images/pic/teachers/alicja-suska-a2235780795d3d36911fb016b4b44e05.webp";